import { create } from "zustand";
import { LatLngTuple } from "leaflet";
import { SelectOption } from "src/components/common/AsyncSelect";

const AUTH_TOKEN_KEY = "constructsmarter:authToken";

export interface User {
    id: string, 
    coords: LatLngTuple,
    accuracy: number,
    email: string,
    firstName: string,
    middleName: string,
    lastName: string,
    userTheme: string,
    profileUrl: string,
    userName: string,
    version: string;
    region: string, 
    unionName: string,
    phaseLevel: string, 
    department: string, 
    role: string, 
    phoneNumber: string, 
    projects: "" | "edit"| "view"| "no", 
    assignments: "" | "yes"| "no", 
    purchases: "" | "approver"| "paid"| "edit"| "view"| "no", 
    perDiem: "" | "editAll"| "edit"| "view"| "no", 
    reports: "" | "editAll"| "edit"| "view"| "no", 
    forms: "" | "editAll"| "edit"| "view"| "no", 
    personel: "" | "edit"| "view"| "no", 
    fleets: "" | "edit"| "view"| "no", 
    calendar: "" | "view"| "no", 
    timeOffs: "" | "editAll"| "viewAll"| "edit"| "view", 
    office: "" | "yes"| "no", 
    allOffice: "" | "edit"| "view"| "no", 
    outside: "" | "locator"| "standby"| "qew"| "runner"| "no", 
    outsideStatus: "" | "edit"| "view"| "no", 
    metrics: "" | "all"| "yes"| "no", 
    newspaper: "" | "edit"| "view"| "no", 
    community: "" | "editAll"| "edit"| "view"| "no", 
    trainings: "" | "edit"| "view"| "no", 
    quitDate: string, 
    birthDay: string, 
    hireDate: string, 
    workPhone: string, 
    extension: string,
    ssn: string, 
    dateCreated: string, 
    dateUpdated: string, 
    background: string,
    creator?: string,
    updater?: string,
    driverLicense: string, 
    address: string, 
    street: string, 
    residence: string, 
    residenceState: string, 
    zipCode: string, 
    lanId: string,
    btlNumber: string, 
    hasMVR?: string, 
    updaterEmail: string, 
    creatorEmail: string,
    creatorName?: string, 
    updaterName?: string, 
    verificationCode: string, 
    dispatch: string, 
    creatorId: string, 
    updaterId: string, 
    void: "yes" | "no",
    voidReason: string,
    validateReason: string,
    competencyServices?: SelectOption[],
    fav: {projects: string[]},
}


interface AuthStore {
    isAuthenticated: boolean,
    isAuthChecked: boolean, 
    user: Partial<User> | null,
    token: string | null,

    setUserInfo:(obj: Partial<User>) => void,
    setAuthenticated: (bool: boolean) => void,
    setAuthChecked: (bool: boolean) => void,
    setToken: (token: string | null) => void,
    clearToken: () => void,
    logout: () => void, 
    reset: () => void,
}

export const useAuthStore = create<AuthStore>((set, get) => ({
    isAuthenticated: false,
    isAuthChecked: false,
    user: { coords: [37.6148754, -122.0874473] as LatLngTuple, accuracy: 0 }, 
    token: typeof window !== "undefined" ? sessionStorage.getItem(AUTH_TOKEN_KEY) : null,

    setUserInfo: (obj) => set(state => state.user?{user: {...state.user, ...obj}}:{user: obj}), 
    setAuthenticated: (bool) => set({isAuthenticated: bool}),  
    setAuthChecked: (bool) => set({isAuthChecked: bool}),  
    setToken: (token) => {
        if (typeof window !== "undefined") {
            if (token) sessionStorage.setItem(AUTH_TOKEN_KEY, token);
            else sessionStorage.removeItem(AUTH_TOKEN_KEY);
        }
        set({ token });
    },
    clearToken: () => {
        if (typeof window !== "undefined") {
            sessionStorage.removeItem(AUTH_TOKEN_KEY);
        }
        set({ token: null });
    },
    logout: () => {
        if (typeof window !== "undefined") {
            sessionStorage.removeItem(AUTH_TOKEN_KEY);
        }
        set({
            isAuthenticated: false,
            isAuthChecked: true,
            user: null,
            token: null,
        });
    },
    reset: () => {
        if (typeof window !== "undefined") {
            sessionStorage.removeItem(AUTH_TOKEN_KEY);
        }
        set({
            isAuthenticated: false,
            isAuthChecked: true,
            token: null,
        });
    }
}));
